// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__BTWPE","title":"style_title__3uxdP","text-container":"style_text-container__3gVM9","text":"style_text__2T4hA"};